module.exports = __webpack_public_path__ + "static/img/DVB3-Biyw4GzV.e4f5008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DVB3-Biyw4GzV.png
// module id = upm9
// module chunks = 16